export const isSafari = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return userAgent.includes('safari') || userAgent.includes('applewebkit');
};

export const isIphone = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return userAgent.includes('iphone');
};

export const isSmartphone = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();

  if (/ipad/i.test(userAgent)) {
    return false;
  }

  return /mobile/i.test(userAgent);
};
